<template>
  <div>
    <div style="margin-bottom: 24px;">
      <div class="title hide-on-small-only">
        <h4>Questões</h4>
        <div style="display: flex;">
          <a
            class="waves-effect waves-light btn"
            style="margin-right: 16px;"
            @click="openFilter = true"
          >
            <i class="material-icons">filter_alt</i>
          </a>
          <router-link
            v-show="checkModulePermission('question', 'create')"
            tag="a"
            class="waves-effect waves-light btn"
            :to="{ name: 'question-create' }"
          >
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>
      <a
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        style="bottom: 88px;"
        @click="openFilter = true"
      >
        <i class="material-icons">filter_alt</i>
      </a>
      <router-link
        tag="a"
        v-show="checkModulePermission('question', 'create')"
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        :to="{ name: 'question-create' }"
      >
        <i class="material-icons">add</i>
      </router-link>

      <div class="hide-on-small-only">
        <table>
          <thead>
            <th width="50%">Título</th>
            <th>Tipo de Resposta</th>
            <th
              width="150px"
              v-show="checkModulePermission('question', 'edit')"
            ></th>
          </thead>
          <tbody>
            <tr v-if="!questions.data.length > 0">
              <td colspan="6" class="center-align">
                {{
                  loadItens
                    ? "Buscando questões..."
                    : "Nenhum questão cadastrada"
                }}
              </td>
            </tr>
            <tr v-else v-for="question in questions.data" :key="question.uuid">
              <td>{{ question.question }}</td>
              <td>{{ getTextTypeQuestion(question.type_response) }}</td>
              <td v-show="checkModulePermission('question', 'edit')">
                <div id="has-button-disabled">
                  <router-link
                    class="waves-effect waves-light btn btn-icon"
                    tag="a"
                    :to="{
                      name: 'question-edit',
                      params: { id: question.uuid }
                    }"
                  >
                    <i class="material-icons">edit</i>
                  </router-link>
                  <disabled-item-button
                    :id="question.uuid"
                    @click="disabled(question.uuid, question.active == 1)"
                    :active="!!question.active"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="questions.data"
          :total-pages="totalPages"
          @changePage="changePage"
          :current-page="currentPage"
        />
      </div>

      <div class="box-list hide-on-med-and-up">
        <ul class="collection">
          <li v-if="!questions.data.length > 0" class="white default-item">
            <p>
              {{
                loadItens
                  ? "Buscando Questões..."
                  : "Nenhum Questões cadastrado"
              }}
            </p>
          </li>
          <li
            v-else
            class="collection-item avatar"
            v-for="question in questions.data"
            :key="question.uuid"
          >
            <div class="collection-item__text">
              <span class="title">{{ question.question }}</span>
              <p>
                <b>Tipo de Resposta:</b>
                <br />
                {{ getTextTypeQuestion(question.type_response) }}
              </p>
            </div>
            <div
              class="collection-item__actions"
              v-show="checkModulePermission('question', 'edit')"
            >
              <router-link
                class="waves-effect waves-light btn btn-icon"
                tag="a"
                :to="{ name: 'question-edit', params: { id: question.uuid } }"
              >
                <i class="material-icons">edit</i>
              </router-link>
              <disabled-item-button
                :id="question.uuid"
                @click="disabled(question.uuid, question.active == 1)"
                :active="!!question.active"
              />
            </div>
          </li>
          <li
            v-if="totalPages > 0 && currentPage !== totalPages"
            @click="changePage(currentPage + 1)"
            class="white default-item get-itens"
          >
            <feather v-if="loadItens" type="loader" animation="spin" />
            <p v-else>Buscar mais itens</p>
          </li>
        </ul>
      </div>
    </div>
    <VSideSlider
      :open="openFilter"
      @close="openFilter = false"
      title="Filtro de Questões"
    >
      <div slot="body">
        <div class="row">
          <div class="input-field col s12">
            <label for="question">Titulo da questão</label>
            <input
              type="text"
              name="question"
              id="question"
              v-model="filter.question"
            />
          </div>
        </div>
      </div>
      <div slot="actions">
        <div class="row">
          <div class="col s12 m6 s-mb-16">
            <button
              class="waves-effect btn-large flat form-button"
              @click="clearFilter"
            >
              Limpar
            </button>
          </div>
          <div class="col s12 m6">
            <button
              class="waves-effect waves-light btn-large form-button"
              @click="handleFilter"
              :class="{ load: loadFilter }"
            >
              <feather v-if="loadFilter" type="loader" animation="spin" />
              <template v-else
                >Filtrar</template
              >
            </button>
          </div>
        </div>
      </div>
    </VSideSlider>
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkModulePermission from "@/services/mixins/checkModulePermission";

export default {
  name: "QuestionList",
  mixins: [checkModulePermission],
  components: {
    VSideSlider: () => import("@/components/VSideSlider")
  },
  data: () => ({
    loadItens: false,
    openFilter: false,
    loadFilter: false,
    filter: {
      question: ""
    },
    typesResponse: [
      {
        value: "BOOLEAN",
        title: "Condicional (Sim ou Não)"
      },
      {
        value: "SHORT_ANSWER",
        title: "Resposta curta"
      },
      {
        value: "LONG_ANSWER",
        title: "Parágrafo"
      },
      {
        value: "CHOICES",
        title: "Caixas de seleção"
      },
      {
        value: "CHECK_BOXES",
        title: "Múltipla escolha"
      },
      {
        value: "LINER_SCALE",
        title: "Escala linear"
      },
      {
        value: "DROPDOWN",
        title: "Lista suspensa"
      }
    ],
    currentPage: 1,
    totalPages: 0,
    questions: {
      data: []
    }
  }),
  computed: {
    ...mapState("User", ["token"])
  },
  mounted() {
    this.getQuestions();
  },
  methods: {
    clearFilter() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = "";
        this.$el.querySelector(`label[for=${key}]`).classList.remove("active");
      });

      this.openFilter = false;
      this.getQuestions(1);
    },
    async handleFilter() {
      this.loadFilter = true;

      let query = Object.keys(this.filter).reduce((curr, keyFilter) => {
        if (this.filter[keyFilter]) {
          return curr + `${keyFilter}:${this.filter[keyFilter]};`;
        }

        return curr;
      }, "&search=");

      if (query != "&search=")
        await this.getQuestions(
          1,
          query.includes(";") ? query.substring(0, query.length - 1) : query
        );

      this.loadFilter = false;
      this.openFilter = false;
    },
    getTextTypeQuestion(val) {
      return this.typesResponse.filter(value => value.value === val)[0].title;
    },
    async getQuestions(page, query = "") {
      const currentPage = page || this.currentPage;

      let url = `questions?page=${currentPage}` + query;

      try {
        this.loadItens = true;
        const response = await this.$http.get(url);

        this.loadItens = false;
        const { questions } = response.body.data;

        this.questions = questions;
        this.totalPages = questions.meta.total;
      } catch (e) {
        console.error(e);
      }
    },
    async changePage(payload) {
      await this.getQuestions(payload);
      this.currentPage = payload;
    },
    disabled(id, active) {
      this.$swal({
        title: "Tem certeza?",
        text: "Este item será desabilitado.",
        icon: "warning",
        buttons: {
          back: {
            text: "Cancelar"
          },
          confirm: {
            text: "Continuar",
            value: "ACTION",
            closeModal: false
          }
        }
      })
        .then(async v => {
          if (v === "ACTION") {
            try {
              await this.$http.post(
                `questions/${id}`,
                {
                  question: {
                    active: active ? 0 : 1
                  }
                },
                {
                  headers: {
                    Authorization: `bearer ${this.token}`
                  }
                }
              );
              const el = document.getElementById(id);

              this.questions.data = this.questions.data.map(val => {
                if (val.uuid === id) {
                  return {
                    ...val,
                    active: active ? 0 : 1
                  };
                }

                return val;
              });

              if (active) el.classList.remove("active");
              else el.classList.add("active");

              this.$swal.stopLoading();
              this.$swal.close();
            } catch (e) {
              throw e;
            }
          }

          return null;
        })
        .catch(err => {
          if (err) {
            this.$swal(
              "Opss..",
              "Falha ao se comunicar com servidor, tente novamente mais tarde",
              "error"
            );
          } else {
            this.$swal.stopLoading();
            this.$swal.close();
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.form-button {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  @media #{$small-and-down} {
    padding: 16px 24px;
    a {
      height: 100%;
      width: 100%;
    }
  }
}
.box-list {
  padding: 0 16px;
}
.circle {
  top: 50%;
  transform: translateY(-50%);
}
@media #{$small-and-down} {
  .collection-item {
    .title {
      padding: 10px 0 !important;
    }
  }
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 48px;
  }
}
.default-item {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
